import { Navigate } from "react-router-dom";
import { getToken } from "../services/Token";
import ApplyLeave from "./ApplyLeave";

const ApplyLeaveOnBehalf = () => {
  const roles = getToken("roles") || "";
  if (!roles.includes("ADMIN")) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <div className="w-3/4 h-3/4 rounded-xl bg-white border border-black my-10 overflow-auto scrollbar-thin">
        <ApplyLeave onBehalf />
      </div>
    </div>
  );
};

export default ApplyLeaveOnBehalf;
